import { Grid2 as Grid } from '@mui/material';
import { TextInput, CountryDropdown, TextArea, PhoneInput, InputList, useInputHelper } from 'framework/form';
import type { DefaultInputPropTypes } from 'framework/form';
import type { CreateEditFormSection } from 'framework/ViewTypes/contentLayout';
import AccountInput from 'domain/finance/ledger/shared/input/AccountInput';
import { NoteAttachmentUploaderInput } from 'domain/shared/artifact/input';
import type useVendorService from '../../useVendorService';

const VendorRequestContactInputs = (props: DefaultInputPropTypes<any>) => {
  const { getSource } = useInputHelper(props);
  const source = getSource();

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextInput source={`${source}.name`} label="Name" />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <PhoneInput source={`${source}.phoneNumber`} label="Phone" />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <TextInput source={`${source}.email`} label="Email" />
      </Grid>
    </Grid>
  );
};

const halfWidth = { xs: 12, md: 6, xl: 6 };
const fullWidth = { xs: 12, md: 12, xl: 12 };

export const getCreateVendorRequestSections = (
  searchVendorCostCentersAccounts: ReturnType<typeof useVendorService>['searchVendorCostCentersAccounts'],
): CreateEditFormSection[] => [
  {
    id: 'vendor-information',
    title: 'Vendor information',
    fields: [
      { id: 'vendorName', size: halfWidth, content: <TextInput source="vendorName" label="Vendor name" /> },
      { id: 'country', size: halfWidth, content: <CountryDropdown source="country" label="Vendor country" /> },
      {
        id: 'taxRegistrationNumber',
        size: halfWidth,
        content: <TextInput source="taxRegistrationNumber" label="Tax registration number" />,
      },
      {
        id: 'costCenterId',
        size: halfWidth,
        content: (
          <AccountInput
            source="costCenterId"
            label="Cost center"
            cacheKey="vendor-accounts"
            loadDataMethod={searchVendorCostCentersAccounts}
          />
        ),
      },
      { id: 'purpose', size: fullWidth, content: <TextArea source="purpose" label="Purpose" /> },
      {
        id: 'expectedCollaborationPeriod',
        size: halfWidth,
        content: <TextInput source="expectedCollaborationPeriod" label="Expected collaboration period" />,
      },
    ],
  },
  {
    id: 'vendor-agreement',
    title: 'Vendor agreement',
    fields: [
      {
        id: 'publicOfferLink',
        size: halfWidth,
        content: <TextInput source="publicOfferLink" label="Public offer link" />,
      },
      {
        id: 'contractDraft',
        size: halfWidth,
        content: <NoteAttachmentUploaderInput isNewDocumentStorage source="contractDraft" label="Contract draft" />,
      },
    ],
  },
  {
    id: 'contacts',
    title: 'Contacts',
    fields: [
      { id: 'phoneNumber', size: halfWidth, content: <PhoneInput source="phoneNumber" label="General vendor phone" /> },
      { id: 'email', size: halfWidth, content: <TextInput source="email" label="General vendor email" /> },
      {
        id: 'contacts',
        size: fullWidth,
        content: (
          <InputList
            source="contacts"
            defaultValue={{ name: '', phoneNumber: '', email: '' }}
            maxFields={3}
            inputTemplate={VendorRequestContactInputs}
          />
        ),
      },
    ],
  },
];
